import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiBadge: {
    styleOverrides: ComponentsOverrides<Theme>['MuiBadge'];
} = {
    styleOverrides: {
        badge: ({ theme }) => ({
            fontSize: '0.625rem',
            fontWeight: 600,
            padding: theme.spacing(0, 0.5),
            letterSpacing: 'unset',
            right: 2,
        }),
    },
};

declare module '@mui/material/Badge' {
    interface BadgePropsColorOverrides {
        negative: true;
    }
}
